module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-20000-efd74c90.png";